import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from '../../../validators/email.validator';
import { passwordValidator } from '../../../validators/password.validator';
import { fieldMatchValidator } from '../../../validators/field-match.validator';
import { AUTH_PASSWORD_VALIDATOR_OPTS } from './auth-password-validator-opts';

export type ChoosePasswordFormGroup = FormGroup<{
  email: FormControl<string>;
  password: FormControl<string>;
  confirmPassword: FormControl<string>;
  eulaAccepted: FormControl<boolean>;
}>;

export function createChoosePasswordFormGroup(opts: { emailDisabled: boolean }): ChoosePasswordFormGroup {
  return new FormGroup(
    {
      email: new FormControl<string>(
        { value: '', disabled: opts.emailDisabled },
        {
          nonNullable: true,
          validators: [Validators.required, emailValidator]
        }
      ),
      password: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, passwordValidator(AUTH_PASSWORD_VALIDATOR_OPTS)]
      }),
      confirmPassword: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      eulaAccepted: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.requiredTrue]
      })
    },
    { validators: fieldMatchValidator('password', 'confirmPassword', 'passwordsMustMatch') }
  );
}
